import React, { useRef, useState } from "react";
import { useIsOverflowing } from "../../hooks";
import Button from "../Button/Button";
import styles from "./oneLineShowMore.module.scss";
const Expandable = ({ id, value, isOverflowing, }) => {
    const [showMore, setShowMore] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles["show-less"] }, showMore ? (React.createElement("span", { className: styles["show-more"] }, value)) : (value)),
        isOverflowing ? (React.createElement(Button, { variant: "text", isInline: true, id: id, onClick: () => setShowMore(showMore ? false : true), className: styles.button },
            "Show ",
            showMore ? "less" : "more")) : null));
};
const OneLineShowMore = ({ id, value, }) => {
    const ref = useRef(null);
    const isOverflowing = useIsOverflowing(ref);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { ref: ref, "aria-hidden": true, className: styles.measurer }, value),
        React.createElement(Expandable, { key: String(isOverflowing), id: id, value: value, isOverflowing: isOverflowing })));
};
export default OneLineShowMore;
//# sourceMappingURL=OneLineShowMore.js.map